/*
 * @providesModule ThemeOverrideProps
 *
 */

import {Platform} from 'react-native';
import type theme from './themes/cobalt-theme.json';

export type AdditionalThemeProps = {
  fontSemiBold?: {fontFamily: string};
  fontExtraBold?: {fontFamily: string};
};
type ThemeOverridePropsType = {
  sheetStyles: Partial<typeof theme.sheetStyles & AdditionalThemeProps>;
};

/**
 * !⚠️ CAUTION: Avoid adding new properties unless they are not managed by the Developer Console or new properties are required.
 * !as we aim to maintain the theme's manageability primarily within the Developer Console.
 */
const ThemeOverrideProps: ThemeOverridePropsType = {
  sheetStyles: {
    fontPrimary: {
      fontFamily: 'OpenSans-Light',
    },
    fontPrimaryItalic: {
      fontFamily: 'OpenSans-LightItalic',
    },
    fontSecondary: {
      fontFamily:
        Platform.OS === 'ios' ? 'OpenSansCondensed-ExtraBold' : 'OpenSans_Condensed-ExtraBold',
    },
    fontRegular: {
      fontFamily: 'OpenSans-Regular',
    },
    fontMedium: {
      fontFamily: 'OpenSans-Medium',
    },
    fontBold: {
      fontFamily: 'OpenSans-Bold',
    },
    fontBoldItalic: {
      fontFamily: 'OpenSans-BoldItalic',
    },
    fontSemiBold: {
      fontFamily: 'OpenSans-SemiBold',
    },
    fontExtraBold: {
      fontFamily: 'OpenSans-ExtraBold',
    },
    textColorCash: {
      color: '#13B657',
    },
    textColorTicketz: {
      color: '#FF3B3B',
    },
  },
};

export default ThemeOverrideProps;
